import { Nullable } from '@jamesgmarks/utilities';
import { ISubscriptions } from '@llws/lift-entity-interfaces';
import { IClientDropdownItem } from '../../../../entity-interfaces/IClientDropdownItem';
import CreditSubscriptionSelection from '../CreditSubscriptionSelection';
import { SelectedCredit } from './types';

/**
 * Renders the subscription selection step of the bulk credit note creation workflow.
 *
 * In addition to listing the client's subscriptions, this component derives the IDs of
 * subscriptions that already have credits staged (via `selectedCredits`) and forwards
 * them to {@link CreditSubscriptionSelection} so those rows can be visually highlighted.
 */
interface SubscriptionSelectionModeProps {
  selectedClient: Nullable<IClientDropdownItem>;
  selectedCredits: SelectedCredit[];
  onSubscriptionSelected: (subscription: Nullable<ISubscriptions>) => void;
}

export const SubscriptionSelectionMode = ({
  selectedClient,
  selectedCredits,
  onSubscriptionSelected,
}: SubscriptionSelectionModeProps) => {
  if (!selectedClient) return null;

  const selectedSubscriptionIds = Array.from(new Set(
    selectedCredits
      .map(selectedCredit => selectedCredit.subscription.id)
      .filter((subscriptionId): subscriptionId is number => subscriptionId != null),
  ));

  return (
    <>
      <CreditSubscriptionSelection
        searchClientId={selectedClient.id}
        selectedSubscriptionIds={selectedSubscriptionIds}
        setSelectedSubscription={(subscription) => {
          onSubscriptionSelected(subscription);
        }}
      />
    </>
  );
};
